import { useRef, useState } from 'react';
import ToetsFields from './ToetsFields';
import { api, errorMessage } from './toetsUtils';

export default function ToetsTemplates({ templates, onRefresh }) {
  const [form, setForm] = useState(null);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [saving, setSaving] = useState(false);
  const submitting = useRef(false);
  const edit = template => {
    setForm(template ? { ...template, parts: template.parts.map(p => ({ title: p.title })) } : { title: '', parts: [] });
    setError(''); setMessage('');
  };
  const save = async event => {
    event.preventDefault();
    if (submitting.current) return;
    submitting.current = true; setSaving(true); setError(''); setMessage('');
    try {
      const payload = { title: form.title.trim(), parts: form.parts.map(p => ({ title: p.title.trim() })) };
      if (form.id) payload.version = form.version;
      await api(form.id ? 'put' : 'post', form.id ? `/templates/${form.id}` : '/templates', payload);
      setForm(null); setMessage('Standaardtoets opgeslagen.'); await onRefresh();
    } catch (err) { setError(errorMessage(err)); }
    finally { submitting.current = false; setSaving(false); }
  };
  const archive = async template => {
    if (submitting.current || !window.confirm(`Standaardtoets “${template.title}” archiveren? Bestaande leerlingresultaten blijven bewaard.`)) return;
    submitting.current = true; setSaving(true); setError(''); setMessage('');
    try {
      await api('delete', `/templates/${template.id}`, { version: template.version });
      if (form?.id === template.id) setForm(null);
      setMessage('Standaardtoets gearchiveerd.'); await onRefresh();
    } catch (err) { setError(errorMessage(err)); }
    finally { submitting.current = false; setSaving(false); }
  };
  return <section className="toets-panel mb-4" aria-label="Standaardtoetsen beheren">
    <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
      <h3 className="h5 m-0">Standaardtoetsen</h3><button type="button" className="btn btn-sm btn-primary" disabled={saving} onClick={() => edit(null)}>+ Standaardtoets</button>
    </div>
    <p className="text-muted">Deze titels en onderdelen zijn beschikbaar voor alle admins en docenten binnen je organisatie. Resultaten vul je per leerling in.</p>
    {error && <div role="alert" className="alert alert-danger">{error}</div>}
    {message && <div role="status" className="alert alert-success">{message}</div>}
    {form && <form className="toets-template-form mb-4" onSubmit={save}>
      <h4 className="h6">{form.id ? 'Standaardtoets bewerken' : 'Nieuwe standaardtoets'}</h4>
      <fieldset disabled={saving}>
        <ToetsFields templateOnly value={form} onChange={setForm} />
        <div className="d-flex gap-2 mt-3"><button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Opslaan…' : 'Opslaan'}</button>
          <button type="button" className="btn btn-outline-secondary" onClick={() => setForm(null)}>Annuleren</button></div>
      </fieldset>
    </form>}
    <div className="toets-template-list">
      {templates.map(t => <div className="toets-template-row" key={t.id}>
        <div><strong>{t.title}</strong><div className="text-muted small">{t.parts.map(p => p.title).join(' · ') || 'Geen onderdelen'}</div></div>
        <div className="d-flex gap-2"><button type="button" className="btn btn-sm btn-outline-primary" disabled={saving} onClick={() => edit(t)}>Bewerken</button>
          <button type="button" className="btn btn-sm btn-outline-danger" disabled={saving} onClick={() => archive(t)}>Archiveren</button></div>
      </div>)}
      {!templates.length && <p className="text-muted">Nog geen standaardtoetsen gedefinieerd.</p>}
    </div>
  </section>;
}
